// Thin wrapper around the native AppReview plugin (iOS-only).
// Triggers SKStoreReviewController's request-review prompt after a player
// has finished a small number of games. iOS rate-limits the prompt itself
// (max 3 times per 365 days), but we also guard locally so we only ever
// ask once per install.
import { Capacitor, registerPlugin } from "@capacitor/core";
import { gameStore } from "@/hooks/useGameStore";

const AppReview = registerPlugin("AppReview");

// Ask after the player has completed this many games total.
const REVIEW_AFTER_GAMES = 4;

export async function maybeRequestReview() {
  if (Capacitor.getPlatform() !== "ios") return;
  const state = gameStore.get();
  if (state.reviewPrompted) return;
  if ((state.gamesPlayed || 0) < REVIEW_AFTER_GAMES) return;
  try {
    await AppReview.requestReview();
    gameStore.markReviewPrompted();
  } catch {
    // no-op: plugin missing (e.g. older native build) or no window scene
  }
}
